const isEmptyString = (str: string) => !str || str.trim() === "";

const isEmptyArray = (arr: any[]) =>
  arr === null || !Array.isArray(arr) || arr.length === 0;

const isEmptyNumber = (num: number) => num === null || num <= 0;

function isEmptyObject(obj: object): boolean {
  return Object.keys(obj).length === 0 || obj === undefined || obj === null;
}

function isEmptyFile(file?: File | null): boolean {
  return file === undefined || file === null || Object.keys(file).length === 0;
}

export {
  isEmptyString,
  isEmptyArray,
  isEmptyNumber,
  isEmptyObject,
  isEmptyFile,
};
